export default {"src":"/_next/static/media/close_16.ee19acb9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};